import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=e021342e&scoped=true&"
import script from "./Palette.vue?vue&type=script&lang=ts&"
export * from "./Palette.vue?vue&type=script&lang=ts&"
import style0 from "./Palette.vue?vue&type=style&index=0&id=e021342e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e021342e",
  null
  
)

export default component.exports